var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.csrBanner},[_c('ImageWithAspectRatio',{staticClass:"text-light",attrs:{"ratio":{ v: 1, h: 3 }},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var itemClass = ref.itemClass;
return [_c('img',{class:[itemClass, _vm.$style.image],attrs:{"src":_vm.BACKGROUND_IMAGE}})]}}])}),_vm._v(" "),_c('PageSection',{},[_c('PageContainer',[_c('CsrBannerContent')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }